import { useCMSPageField } from '@/cms/fields'

import { useFiltersQuery } from '@/domain/prices/filters/hooks'

import { useInitializePriceTable, usePriceTableState } from '@/domain/prices/hooks'
import { usePricesStore } from '@/infrastructure/prices/usePricesStore'
import { LoadingSpinner, tk } from '@sunwebgroup/ui-components'
import { useMount } from 'react-use'
import { css, styled } from 'styled-components'
import { AlertService, AlertServiceTab } from './AlertService'
import Filters from './Filters'
import { GridTabs } from './Filters/GridTabs'
import { MonthFilter } from './Filters/MonthFilter'
import { GoBack } from './GoBack'
import { GridTabsProvider } from './GridTabsContext'
import { PriceConfigurator } from './PriceConfigurator'

interface PriceTableProps {
  onClickBack?: () => void
}

const SHOW_NEXT_SEASON_ALERT_TAB = false

const Wrapper = styled.div<{ $disabled: boolean }>`
  display: flex;
  position: relative;
  justify-content: center;

  max-width: 1312px;

  flex-direction: column;

  & > * {
    margin-bottom: ${tk('spacing_md')};
  }
  ${({ $disabled }) =>
    $disabled
    && css`
      opacity: 0.25;
      pointer-events: none;
    `}
`

const Loader = styled(LoadingSpinner)`
  margin: auto;
`

function PriceTableComponent({ onClickBack }: PriceTableProps) {
  const { isLoading: filtersLoading, data: filtersData } = useFiltersQuery()
  const { isLoading } = usePriceTableState()
  const { initialize } = useInitializePriceTable()
  const analytics = useCMSPageField('PDP.pricetable.analytics')

  useMount(() => {
    initialize({ analytics })
  })

  if (filtersLoading || !filtersData) {
    return <Loader />
  }

  return (
    <GridTabsProvider>
      <Wrapper $disabled={isLoading} data-qa-pt-ready={!isLoading}>
        <GoBack onClick={onClickBack} />
        <Filters />
        <GridTabs>
          <MonthFilter />
          {SHOW_NEXT_SEASON_ALERT_TAB && <AlertServiceTab />}
        </GridTabs>
        <AlertService />
        <PriceConfigurator />
      </Wrapper>
    </GridTabsProvider>
  )
}

export function PriceTable({ onClickBack }: PriceTableProps) {
  const { showPriceTable } = usePricesStore()

  if (!showPriceTable) {
    return null
  }

  return <PriceTableComponent onClickBack={onClickBack} />
}
